module.exports = __webpack_public_path__ + "img/eliza3.7304a30e.png";